import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { injectModels } from "../../redux/injectModels";
import { Link } from "react-router-dom";
import { Routes } from "../../constants";
import { publicIpv4 } from "public-ip";
import { JWT } from "../shared";
import Jwt from "../shared/Jwt";

function Login(props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [passError, setPassError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const emailRegex =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const navigate = useNavigate();

  useEffect(() => {
    let email = localStorage.getItem("RememberMeEmail");
    let password = localStorage.getItem("Password");
    const id = localStorage.getItem("UserId");
    if (email != null && password != null) {
      setEmail(email);
      setPassword(password);
      setRememberMe(true);
    }
    if (id != null) {
      navigate(Routes.DASHBOARD);
    } else {
      navigate(Routes.DEFAULT);
    }
  }, []);

  const handleEmailChange = (e) => {
    e.preventDefault();
    const val = e.target.value.trim();
    if (val === "") {
      setEmailError("Email is required");
    } else if (!emailRegex.test(val)) {
      setEmailError("Please enter the correct Email!");
    } else {
      setEmailError("");
    }

    setEmail(val);
  };

  const handlePasswordChange = (e) => {
    e.preventDefault();
    const val = e.target.value;
    if (val.trim() === "") {
      setPassError("Password is required");
    } else {
      setPassError("");
    }
    setPassword(val);
  };

  const togglePassword = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };

  const handleRememberMeChange = (e) => {
    setRememberMe(e.target.checked);
  };

  function getDeviceInfo() {
    var userAgent = navigator.userAgent;
    var platform = navigator.platform;

    // Detecting the browser and version
    var browser, version;

    if (userAgent.indexOf("Brave") > -1) {
      browser = "Brave";
      version = userAgent.match(/Chrome\/([\d.]+)/)[1]; // Brave uses the same versioning as Chrome
    } else if (userAgent.indexOf("Edge") > -1) {
      browser = "Microsoft Edge";
      version = userAgent.match(/Edg\/([\d.]+)/)[1]; // Extract Edge version
    } else if (
      userAgent.indexOf("Chrome") > -1 &&
      userAgent.indexOf("Safari") > -1
    ) {
      browser = "Google Chrome";
      version = userAgent.match(/Chrome\/([\d.]+)/)[1]; // Extract Chrome version
    } else if (
      userAgent.indexOf("Safari") > -1 &&
      userAgent.indexOf("Chrome") === -1
    ) {
      browser = "Safari";
      version = userAgent.match(/Version\/([\d.]+)/)[1]; // Extract Safari version
    } else if (userAgent.indexOf("Firefox") > -1) {
      browser = "Mozilla Firefox";
      version = userAgent.match(/Firefox\/([\d.]+)/)[1]; // Extract Firefox version
    } else if (
      userAgent.indexOf("MSIE") > -1 ||
      userAgent.indexOf("Trident/") > -1
    ) {
      browser = "Internet Explorer";
      version = userAgent.match(/(MSIE|rv:)([\d.]+)/)[2]; // Extract IE version
    } else {
      browser = "Unknown Browser";
      version = "Unknown Version";
    }

    // Detecting the operating system
    var os;
    if (platform.indexOf("Win") !== -1) {
      os = "Windows";
    } else if (platform.indexOf("Mac") !== -1) {
      os = "MacOS";
    } else if (platform.indexOf("Linux") !== -1) {
      os = "Linux";
    } else if (/Android/.test(userAgent)) {
      os = "Android";
    } else if (/iPhone|iPad|iPod/.test(userAgent)) {
      os = "iOS";
    } else {
      os = "Unknown OS";
    }

    // Detecting the device type
    var device = /Mobi|Android|iPhone/.test(userAgent) ? "Mobile" : "Desktop";

    return {
      browser: browser,
      version: version,
      os: os,
      device: device,
    };
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    props.application.setLoading(true, "Login!");
    var deviceInfo = getDeviceInfo();
    let valid = true;

    if (password === "") {
      setPassError("Password is required");
      valid = false;
    } else {
      setPassError("");
    }

    if (email.trim() === "") {
      setEmailError("Email is required");
      valid = false;
    } else if (!emailRegex.test(email)) {
      setEmailError("Please enter the correct Email!");
      valid = false;
    } else {
      setEmailError("");
    }
    if (!valid) {
      props.application.setLoading(false, "");
      return;
    } else {
      const data = {
        email: email.trim(),
        password: password,
        ip_address: "1.1.1.1",
        browser: `${deviceInfo.browser} ${deviceInfo.version}`,
        os: deviceInfo.os,
        device: deviceInfo.device,
        // ip_address:publicIpAddress && publicIpAddress
      };
      try {
        props.application.setLoading(true);
        const res = await props.auth.userLogin(data);
        if (res.success) {
          props.application.setLoading(false);
          if (rememberMe) {
            localStorage.setItem("RememberMeEmail", email);
            localStorage.setItem("Password", password);
          } else {
            localStorage.removeItem("RememberMeEmail");
            localStorage.removeItem("Password");
          }
          JWT.setJwt(res.access_token);
          // Jwt.setJwt("eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NTE5NjYzOTksInN1YiI6ImRldl90ZXN0QG1haWwuY29tIn0.gdJgQgh3uRJVR9N7MpQ0SOsydNm3kyLrsb9wJ7l9Apw")
          localStorage.setItem("userRole", res && res.userRole);
          // localStorage.setItem("isAuthenticated", true);
          navigate(Routes.DASHBOARD);
          toast.dismiss();
          toast.success("Logged in successfully!", {
            position: toast.POSITION.TOP_CENTER,
          });
          toast.dismiss();
          setError("");
        } else {
          props.application.setLoading(false);
          setError(res.message);
          localStorage.clear();
          return;
        }
      } catch (err) {
        props.application.setLoading(false);
        console.log(err);
        setError(err.message);
      }
    }
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-xl-4 col-lg-5 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center py-4 lf-logo">
                  <a
                    href="index.html"
                    className="lf-logo d-flex align-items-center w-auto"
                  >
                    <img src="/assets/img/logo.png" alt="" />
                  </a>
                </div>
                <div className="card login-form mb-3">
                  <div className="card-body p-4">
                    <div className="pb-2 pt-3"></div>
                    <form
                      className="row g-3 needs-validation"
                      action="index.html"
                      onSubmit={handleSubmit}
                    >
                      <div className="col-12">
                        <label htmlFor="yourUsername" className="form-label">
                          Email
                        </label>
                        <div className="input-group has-validation">
                          <span
                            className="input-group-text"
                            id="inputGroupPrepend"
                          >
                            <i className="fa-regular fa-envelope"></i>{" "}
                          </span>
                          <input
                            type="text"
                            name="username"
                            className="form-control"
                            id="yourUsername"
                            placeholder="Email*"
                            autoComplete="off"
                            value={email}
                            onChange={handleEmailChange}
                          />
                        </div>

                        {emailError && (
                          <span className="error" style={{ color: "red" }}>
                            {emailError}
                          </span>
                        )}
                      </div>

                      <div className="col-12">
                        <label htmlFor="yourPassword" className="form-label">
                          Password
                        </label>
                        <div className="input-group has-validation">
                          <span
                            className="input-group-text"
                            id="inputGroupPrepend"
                          >
                            <i className="fa-solid fa-lock"></i>
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control"
                            name="password"
                            id="password"
                            placeholder="Password*"
                            value={password}
                            onChange={handlePasswordChange}
                          />

                          <span
                            className="btn btn-outline-secondary eye-splash"
                            id="toggle"
                            onClick={togglePassword}
                          >
                            {showPassword ? (
                              <i className="fa-solid fa-eye"></i>
                            ) : (
                              <i className="fa-solid fa-eye-slash"></i>
                            )}
                          </span>
                        </div>
                        {passError && (
                          <span className="error" style={{ color: "red" }}>
                            {passError}
                          </span>
                        )}
                      </div>
                      <div className="col-12 frgt-psw">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="remember"
                            id="rememberMe"
                            checked={rememberMe}
                            onChange={handleRememberMeChange}
                          />
                          <label className="form-check-label" for="rememberMe">
                            Remember me
                          </label>
                        </div>
                        <Link to={Routes.FORGOTPASSWORD}>Forgot Password</Link>
                      </div>
                      {error && (
                        <div className="col-12">
                          <div className="alert alert-danger">{error}</div>
                        </div>
                      )}
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Login
                        </button>
                      </div>
                      <div className="col-12 text-center lg-link"></div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
export default injectModels(["application", "auth"])(Login);
